/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import React from 'react';

import {
    ImageUnavailable,
    StarRating,
    FlexRow,
    FlexCol,
    StringHelper,
} from 'sarsaparilla';
import * as MapHelper from 'shared-ui/maps/helpers/mapHelper';

import LocationName from './LocationName';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    index: PropTypes.number,
    item: PropTypes.shape({
        preview_image_url: PropTypes.string,
        name: PropTypes.string,
        average_rating: PropTypes.number,
        parent_name: PropTypes.string,
        entity_id: PropTypes.string,
        entity_type: PropTypes.string,
        city: PropTypes.string,
        state_code: PropTypes.string,
        reservable: PropTypes.bool,
        price_range: PropTypes.shape({
            amount_min: PropTypes.number,
            amount_max: PropTypes.number,
            per_unit: PropTypes.string,
        }),
    }),
    onCardSelect: PropTypes.func,
};

export function LocationsListCard(props) {
    const detailURL = MapHelper.getTargetUri(props.item);

    const priceUnit = props.item.price_range?.per_unit || '';
    let priceStr = '';
    if (props.item.price_range) {
        const minAmount = props.item.price_range.amount_min;
        const maxAmount = props.item.price_range.amount_max;

        if (minAmount > -1) {
            if (minAmount === maxAmount) {
                priceStr = `$${Math.floor(minAmount)}`;
            }
            priceStr = `$${Math.floor(minAmount)} - $${Math.floor(maxAmount)}`;
        }
    }

    let cardLabel = null;
    if (priceStr) {
        cardLabel = `${props.item.name} - ${priceStr} ${priceUnit}`;
    }

    const averageRating = Number.parseFloat(props.item.average_rating || 0.0);

    let subLabel = '';
    if (props.item.parent_name) {
        subLabel = StringHelper.toTitleCase(props.item.parent_name);
    }
    if (props.item.city && props.item.state_code) {
        if (subLabel) {
            subLabel += ' in ';
        }
        subLabel += props.item.state_code;
    }

    return (
        <a
            href={detailURL}
            className="recommendations-list-card-wrapper"
            onClick={() => {
                if (props.onCardSelect) {
                    props.onCardSelect(props.item, detailURL, props.index);
                }
            }}
            aria-label={cardLabel}
            target="_blank"
            rel="noopener noreferrer"
        >
            <FlexRow hasGutters={false} className="recommendations-list-card">
                <FlexCol xs="variable" className="mr-2">
                    <div className="recommendations-list-card--image-wrap">
                        {props.item.preview_image_url && (
                            <img
                                src={props.item.preview_image_url}
                                alt={props.item.name}
                                className="recommendations-list-card--image"
                            />
                        )}
                        {!props.item.preview_image_url && <ImageUnavailable />}
                    </div>
                </FlexCol>
                <FlexCol xs="auto">
                    <FlexRow flexDirection="column" hasGutters={false}>
                        <FlexCol xs={12}>
                            <LocationName
                                className="recommendations-list-card--name"
                                name={props.item.name}
                            />
                        </FlexCol>
                        <FlexCol xs={12} className="recommendations-list-card--location">
                            <div>{subLabel}</div>
                        </FlexCol>

                        {props.startDate ? (
                            <FlexCol xs={12} className="recommendations-list-card--price">
                                {props.item.price_range && `${priceStr} / ${priceUnit}`}
                            </FlexCol>
                        ) : (
                            <FlexCol
                                xs={12}
                                className="recommendations-list-card--star-rating"
                            >
                                {averageRating > 0 && (
                                    <StarRating
                                        rating={averageRating}
                                        format="fmt2"
                                        size="sm"
                                    />
                                )}
                            </FlexCol>
                        )}
                    </FlexRow>
                </FlexCol>
            </FlexRow>
        </a>
    );
}

LocationsListCard.propTypes = propTypes;

export default LocationsListCard;
